import { api } from "../api/client";

const GA4_ID = "G-6N3Q8YY87D";
const ADS_ID = "AW-10974714621";
const ACCOUNT_SIGNUP_SEND_TO = "AW-10974714621/HjEkCN_WxdscEP21k_Eo";

type SignupConversionResponse = {
  conversionKey: "account_signup_completed" | null;
  method?: "microsoft";
  destination?: string;
};

export async function trackMicrosoftSignupCompletion(
  navigate: (destination: string) => void = (destination) => window.location.assign(destination),
): Promise<boolean> {
  let conversion: SignupConversionResponse;
  try {
    conversion = await api.post<SignupConversionResponse>("/auth/microsoft/signup-conversion/consume", {});
  } catch {
    return false;
  }
  if (conversion.conversionKey !== "account_signup_completed" || conversion.method !== "microsoft") {
    return false;
  }

  const script = document.createElement("script");
  script.async = true;
  script.referrerPolicy = "no-referrer";
  script.src = `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`;
  document.head.appendChild(script);

  const windowWithDataLayer = window as typeof window & { dataLayer?: unknown[] };
  const dataLayer = windowWithDataLayer.dataLayer ?? [];
  windowWithDataLayer.dataLayer = dataLayer;
  const gtag = function (..._args: unknown[]) {
    dataLayer.push(arguments);
  };
  gtag("js", new Date());
  gtag("config", GA4_ID, { send_page_view: false });
  gtag("config", ADS_ID);
  gtag("event", "sign_up", { method: "microsoft", signup_type: "account" });
  gtag("event", "account_signup_completed", { method: "microsoft" });
  const destination = conversion.destination;
  if (destination?.startsWith("/") && !destination.startsWith("//")) {
    await new Promise<void>((resolve) => {
      let completed = false;
      const finish = () => {
        if (completed) return;
        completed = true;
        resolve();
      };
      gtag("event", "conversion", {
        send_to: ACCOUNT_SIGNUP_SEND_TO,
        event_callback: finish,
        event_timeout: 1500,
      });
      window.setTimeout(finish, 1700);
    });
    navigate(destination);
  } else {
    gtag("event", "conversion", { send_to: ACCOUNT_SIGNUP_SEND_TO });
  }
  return true;
}
